/**
 * @generated SignedSource<<c6b06aa7226f7810b72c6e813284dbe7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExperienceSettingsNotificationsFormFieldsFragment$data = {
  readonly emailTemplates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly kind: string;
        readonly " $fragmentSpreads": FragmentRefs<"EditEmailTemplateFormFragment">;
      };
    }>;
  };
  readonly id: string;
  readonly " $fragmentType": "ExperienceSettingsNotificationsFormFieldsFragment";
};
export type ExperienceSettingsNotificationsFormFieldsFragment$key = {
  readonly " $data"?: ExperienceSettingsNotificationsFormFieldsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExperienceSettingsNotificationsFormFieldsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExperienceSettingsNotificationsFormFieldsFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailTemplateNodeConnection",
      "kind": "LinkedField",
      "name": "emailTemplates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailTemplateNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EmailTemplate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "kind",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EditEmailTemplateFormFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};
})();

(node as any).hash = "7dc9606dd3146baaafd96afa20c31a74";

export default node;
